import { render, staticRenderFns } from "./WebsiteHome.vue?vue&type=template&id=610e9864&scoped=true"
import script from "./WebsiteHome.vue?vue&type=script&lang=js"
export * from "./WebsiteHome.vue?vue&type=script&lang=js"
import style0 from "./WebsiteHome.vue?vue&type=style&index=0&id=610e9864&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610e9864",
  null
  
)

export default component.exports